import { useEffect, useState } from "react";
import { fetchAccessGroupCatalogs, type AccessGroup } from "../../api/providerAccess";

/** The access groups each provider offers, keyed by vendor id. */
export type AccessGroupCatalog = Record<string, AccessGroup[]>;

/**
 * Loads `GET /api/providers/access-groups` once. A failure leaves the catalogue empty: the form then shows no group choices
 * for a provider granted per group, and cannot enable it, rather than offering ids it cannot name.
 */
export function useAccessGroupCatalog(): AccessGroupCatalog {
  const [catalog, setCatalog] = useState<AccessGroupCatalog>({});

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const result = await fetchAccessGroupCatalogs();
      if (!cancelled && result.kind === "ok") {
        setCatalog(Object.fromEntries(result.response.map((provider) => [provider.vendorId, provider.groups])));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return catalog;
}
